module.exports = __webpack_public_path__ + "img/cert-bg-globe.24e88679.png";